/**
 * Static prototype profile-search service — backed by the mock store.
 * Used to look up a researcher profile by RUN when building a team.
 */

import { ProfileSearchResponse } from '../types/profile';
import { db, delay } from '../mocks/store';

class ProfileService {
  async searchProfileByRun(
    run: string,
    _token: string
  ): Promise<ProfileSearchResponse> {
    await delay(null, 250);
    const normalized = run.trim();
    const user = db.users.find((u) => u.userProfile?.run === normalized);

    if (user && user.userProfile) {
      const p = user.userProfile;
      return {
        email: user.email,
        name: user.name,
        run: p.run ?? normalized,
        doctorateYear: p.doctorateYear ?? null,
        doctorateMonth: p.doctorateMonth ?? null,
        facultadUC: p.facultadUC ?? null,
        unidadAcademica: p.unidadAcademica ?? null,
        canApply: p.canApply ?? true,
        platformMessage: p.platformMessage,
      };
    }

    // Unknown RUN: return a generic, plausible profile so the flow continues.
    return {
      email: `investigador_${normalized.replace(/[^0-9kK]/g, '')}@uc.cl`,
      name: 'Investigador/a Demostración',
      run: normalized,
      doctorateYear: 2018,
      doctorateMonth: 6,
      facultadUC: 'Ingeniería',
      unidadAcademica: 'FAC-A',
      canApply: true,
    };
  }
}

class ProfileSearchServiceError extends Error {
  constructor(
    message: string,
    public error: string,
    public statusCode: number
  ) {
    super(message);
    this.name = 'ProfileSearchServiceError';
  }
}

const profileService = new ProfileService();
export default profileService;
export { ProfileSearchServiceError };
